import ClientActions from './client-actions';

window.addEventListener('load', () => {
    if (document.getElementById('login-frontend-cookie-cleanup')) {
        const clientActions: ClientActions = new ClientActions();

        clientActions.cookieCleanup();
    }
});
